import Image from 'src/components/atoms/Image';
import ProgressiveImage from 'src/components/atoms/ProgressiveImage';

const FilledImage = ({ url, placeholderUrl, ...props }) => {
  if (placeholderUrl) {
    return (
      <ProgressiveImage
        src={url}
        placeholderSrc={placeholderUrl}
        className={props.className || 'relative inset-0 h-full w-full object-cover'}
        {...props}
      />
    );
  } else {
    return (
      <Image
        src={url}
        placeholderSrc={placeholderUrl}
        className={props.className || 'relative inset-0 h-full w-full object-cover'}
        {...props}
      />
    );
  }
};

export default FilledImage;
